import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../../components/PageHeader';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const OurStory = () => {
  return (
    <div className="w-full bg-white">
      <PageHeader 
        title="Our Story" 
        description="A family-owned business built on practical experience, global reach, and a commitment to listening first." 
      />
      
      <section className="py-20 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="prose prose-lg prose-slate max-w-none">
          <h2 className="text-brand-navy font-bold text-3xl mb-6">The Boes & Boes Mission</h2>
          <div className="bg-brand-light border-l-4 border-brand-green p-6 rounded-r-xl mb-12">
            <p className="text-xl font-semibold text-brand-navy m-0">
              "Help organizations protect people, maintain operations, and build confident leaders through practical planning, training, exercises, and continuous improvement."
            </p>
          </div>

          <p>
            Boes & Boes Training Consultants LLC is a Woman-Owned Small Business (WOSB) founded by Linda and Terry Boes. Together, we built this company to bridge a critical gap in the industry: the disconnect between theoretical emergency plans and practical, on-the-ground reality.
          </p>

          <p>
            For nearly two decades, we have worked across more than 30 countries, helping complex, high-risk organizations prepare for the unexpected. From nuclear facilities and oil refineries to government agencies and Fortune 100 manufacturers, we have seen what works—and more importantly, what fails when the pressure is real.
          </p>

          <h3 className="text-brand-navy font-bold text-2xl mt-12 mb-4">We Listen First</h3>
          <p>
            Our core philosophy is simple: we avoid canned solutions. Every organization has unique risks, distinct cultures, and different resources. An Emergency Action Plan that works for a corporate headquarters will fail on an industrial plant floor. We listen to your team, assess your actual environment, and build programs that fit your operations.
          </p>

          <h3 className="text-brand-navy font-bold text-2xl mt-12 mb-4">Returning Home to Fort Wayne</h3>
          <p>
            After years of constant international travel and deployments to disaster zones, we made the deliberate choice to return to Fort Wayne, Indiana. We wanted to be closer to our family—including our five children and four grandchildren—and share our home with our two rescue dogs. 
          </p>
          <p>
            Today, we are proud to bring global-level emergency management and organizational development expertise to the regional business community here in the Midwest, while continuing to serve our valued clients across the nation and around the world.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mt-16">
          <Link to="/about/linda-boes" className="flex items-center gap-4 p-6 bg-brand-light rounded-xl border border-slate-200 hover:border-brand-navy transition-colors group">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-sm text-brand-navy">
              <SafeIcon icon={FiIcons.FiUser} className="text-2xl" />
            </div>
            <div>
              <h4 className="font-bold text-lg text-brand-navy group-hover:text-brand-green transition-colors">Linda Boes</h4>
              <p className="text-sm text-slate-600">CEO & Consultant</p>
            </div>
          </Link>
          <Link to="/about/terry-boes" className="flex items-center gap-4 p-6 bg-brand-light rounded-xl border border-slate-200 hover:border-brand-navy transition-colors group">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-sm text-brand-navy">
              <SafeIcon icon={FiIcons.FiUser} className="text-2xl" />
            </div>
            <div>
              <h4 className="font-bold text-lg text-brand-navy group-hover:text-brand-green transition-colors">Terry Boes</h4>
              <p className="text-sm text-slate-600">Managing Partner</p>
            </div>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default OurStory;